import check, { checkComponentNameIsValid } from "./util/check.js";
import { COELEMENT_DATA_KEY_PREFIX } from "./util/const.js";
/**
 * Gets the eoelement instance of the class-component of the given name
 * @param name The class-component name
 * @param el The element
 */
export default (name, el) => {
    checkComponentNameIsValid(name);
    // deno-lint-ignore no-explicit-any
    const coel = el[COELEMENT_DATA_KEY_PREFIX + name];
    check(coel, `no coelement named: ${name}, on the dom: ${el.tagName}`);
    return coel;
};
